import { Draft } from '@reduxjs/toolkit';
import BigNumber from 'bignumber.js';
import { getProduct } from '#/products/domain';

import { DraftLeg, DraftOptionLeg, DraftFutureLeg } from './types';

export function isOptionLeg(leg: DraftLeg): leg is Draft<DraftOptionLeg> {
  return leg.kind === 'OPTION';
}

export function isFutureLeg(leg: DraftLeg): leg is Draft<DraftFutureLeg> {
  return leg.kind === 'FUTURE';
}

export function isHedgeLeg(leg: DraftLeg): leg is Draft<DraftFutureLeg> {
  return isFutureLeg(leg) && leg.isHedge;
}

export function validateHedgeLegQuantity(hedgeLeg: DraftFutureLeg) {
  const { productCode } = hedgeLeg;
  const { contractSize, minContractIncrement } = getProduct(productCode);

  const minIncrement = minContractIncrement * contractSize;
  const hedgeQuantity = parseFloat(hedgeLeg.quantity ?? '');

  const isQuantityDivisibleByIncrement =
    hedgeQuantity > 0 && BigNumber(hedgeQuantity).mod(minIncrement).isZero();

  const errorMsg = !isQuantityDivisibleByIncrement
    ? `Hedge Leg's quantity must be a multiple of ${minIncrement}`
    : undefined;

  return { isValid: isQuantityDivisibleByIncrement, errorMsg };
}
